<template>
    <div class="mine-container">
        <!-- 电脑端样式 -->
        <div v-if="isDesktop" class="desktop-container">
            <div class="content">
                <div class="profile-card">
                    <div class="profile-header">
                        <div class="avatar-section">
                            <el-avatar :size="80" :src="userInfo.avatar || defaultAvatar" />
                            <div class="user-basic">
                                <h2 class="user-name">{{ userInfo.nickname || '管理员' }}</h2>
                                <p class="user-role">{{ userInfo.username || '-' }}</p>
                            </div>
                        </div>
                        <el-button type="primary" icon="el-icon-edit" @click="handleEditProfile">编辑资料</el-button>
                    </div>
                    
                    <el-divider />
                    
                    <div class="info-section">
                        <h3 class="section-title">基本信息</h3>
                        <div class="info-grid">
                            <div class="info-item">
                                <span class="info-label">联系方式</span>
                                <span class="info-value">{{ userInfo.mobile || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">邮箱</span>
                                <span class="info-value">{{ userInfo.email || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">最后登录</span>
                                <span class="info-value">{{ userInfo.last_login_date || '-' }}</span>
                            </div>
                            <div class="info-item">
                                <span class="info-label">注册时间</span>
                                <span class="info-value">{{ userInfo.register_date || '-' }}</span>
                            </div>
                        </div>
                    </div>
                    
                    <el-divider />
                    
                    <div class="action-section">
                        <h3 class="section-title">账号安全</h3>
                        <div class="action-list">
                            <div class="action-item" @click="handleChangePassword">
                                <div class="action-left">
                                    <i class="el-icon-lock action-icon" />
                                    <div class="action-info">
                                        <span class="action-name">修改密码</span>
                                        <span class="action-desc">定期修改密码可以保护账号安全</span>
                                    </div>
                                </div>
                                <i class="el-icon-arrow-right action-arrow" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 手机端样式 -->
        <div v-else class="mobile-container">
            <div class="mobile-profile-card">
                <div class="mobile-profile-header">
                    <van-image
                        round
                        width="80px"
                        height="80px"
                        :src="userInfo.avatar || defaultAvatar"
                    />
                    <div class="mobile-user-info">
                        <h2 class="mobile-user-name">{{ userInfo.name || '管理员' }}</h2>
                        <p class="mobile-user-role">{{ userInfo.role || '系统管理员' }}</p>
                    </div>
                </div>
                
                <van-cell-group title="基本信息">
                    <van-cell title="用户名" :value="userInfo.username || '-'" />
                    <van-cell title="邮箱" :value="userInfo.email || '-'" />
                    <van-cell title="手机号" :value="userInfo.phone || '-'" />
                    <van-cell title="部门" :value="userInfo.department || '-'" />
                    <van-cell title="最后登录" :value="userInfo.lastLogin || '-'" />
                    <van-cell title="注册时间" :value="userInfo.createTime || '-'" />
                </van-cell-group>
                
                <van-cell-group title="账号安全">
                    <van-cell title="修改密码" is-link @click="handleChangePassword">
                        <template #icon>
                            <van-icon name="lock" class="cell-icon" />
                        </template>
                    </van-cell>
                </van-cell-group>
            </div>
        </div>

        <!-- 编辑资料弹窗 -->
        <el-dialog title="编辑个人资料" :visible.sync="editDialogVisible" width="500px">
            <el-form :model="editForm" :rules="editRules" ref="editForm" label-width="80px">
                <!-- 头像上传 -->
                <el-form-item label="头像">
                    <div class="avatar-upload-wrapper">
                        <el-avatar :size="80" :src="editForm.avatar || defaultAvatar" />
                        <el-upload
                            class="avatar-uploader"
                            action="https://up-z0.qiniup.com"
                            :data="uploadData"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :before-upload="beforeAvatarUpload"
                            accept=".jpeg,.jpg,.gif,.png"
                        >
                            <el-button size="small" type="primary" icon="el-icon-upload2" :loading="uploadLoading">更换头像</el-button>
                        </el-upload>
                    </div>
                </el-form-item>
                <el-form-item label="昵称" prop="nickname">
                    <el-input v-model="editForm.nickname" placeholder="请输入昵称"></el-input>
                </el-form-item>
                <el-form-item label="邮箱" prop="email">
                    <el-input v-model="editForm.email" placeholder="请输入邮箱"></el-input>
                </el-form-item>
                <el-form-item label="手机号" prop="username">
                    <el-input v-model="editForm.username" placeholder="请输入手机号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editDialogVisible = false">取消</el-button>
                <el-button type="primary" @click="handleSaveProfile" :loading="saveLoading">保存</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getProfile,updateProfile } from '@/api/mine'
import { getQiniuToken } from '@/api/public'
export default {
    name: 'PersonalCenter',
    data() {
        return {
            // 响应式设计变量
            isDesktop: true,
            // 默认头像
            defaultAvatar: 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png',
            // 用户信息
            userInfo: [],
            // 编辑弹窗
            editDialogVisible: false,
            saveLoading: false,
            uploadLoading: false,
            editForm: {
                nickname: '',
                username: '',
                avatar: '',
                email: ''
            },
            editRules: {
                nickname: [{ required: true, message: '请输入昵称', trigger: 'blur' }],
                email: [
                    { required: true, message: '请输入邮箱', trigger: 'blur' },
                    { type: 'email', message: '邮箱格式不正确', trigger: 'blur' }
                ],
                username: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3-9]\d{9}$/, message: '手机号格式不正确', trigger: 'blur' }
                ]
            },
            // 七牛上传配置
            uploadData: {
                token: '',
                key: ''
            },
            uploadDomain: 'https://cdn.puditech.com/'
        }
    },
    mounted() {
        this.checkScreenSize();
        window.addEventListener('resize', this.handleResize);
        this.loadUserInfo();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    methods: {
        // 检查屏幕尺寸
        checkScreenSize() {
            this.isDesktop = window.innerWidth > 768;
        },
        // 处理窗口大小变化
        handleResize() {
            this.checkScreenSize();
        },
        // 加载用户信息
        loadUserInfo() {
            getProfile().then(res => {
                if (res.code === 200) {
                    this.userInfo = res.data
                }
            })
        },
        // 编辑资料
        handleEditProfile() {
            this.editForm = {
                nickname: this.userInfo.nickname,
                username: this.userInfo.username,
                avatar: this.userInfo.avatar,
                email: this.userInfo.email,
            };
            // 获取七牛Token
            this.getUploadToken();
            this.editDialogVisible = true;
        },
        // 获取上传Token
        getUploadToken() {
            getQiniuToken().then(res => {
                if (res.code === 200) {
                    this.uploadData.token = res.data;
                }
            });
        },
        // 头像上传前处理
        beforeAvatarUpload(file) {
            const isImage = /\.(jpeg|jpg|gif|png)$/i.test(file.name);
            if (!isImage) {
                this.$message.error('请上传图片文件（jpeg/jpg/gif/png）');
                return false;
            }
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isLt2M) {
                this.$message.error('图片大小不能超过 2MB');
                return false;
            }
            // 生成随机文件名
            const suffix = file.name.substring(file.name.lastIndexOf('.') + 1);
            const randomStr = this.createNonceStr();
            this.uploadData.key = 'avatar/' + randomStr + '.' + suffix;
            this.uploadLoading = true;
            return true;
        },
        // 头像上传成功
        handleAvatarSuccess(res, file) {
            this.uploadLoading = false;
            if (res && res.key) {
                this.editForm.avatar = this.uploadDomain + res.key;
                this.uploadLoading = false;
                this.$message.success('头像上传成功');
            } else {
                this.$message.error('上传失败，请重试');
            }
        },
        // 生成随机字符串
        createNonceStr() {
            const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
            let res = '';
            for (let i = 0; i < 16; i++) {
                res += chars[Math.floor(Math.random() * chars.length)];
            }
            return res;
        },
        // 保存资料
        handleSaveProfile() {
            this.$refs.editForm.validate(valid => {
                if (valid) {
                    this.saveLoading = true;
                    // TODO: 调用保存 API
                    updateProfile(this.editForm).then(res => {
                        this.userInfo.nickname = this.editForm.nickname;
                        this.userInfo.email = this.editForm.email;
                        this.userInfo.username = this.editForm.username;
                        this.userInfo.avatar = this.editForm.avatar;
                        // 更新 Vuex store 中的用户信息，头部组件会自动刷新
                        this.$store.commit('updateUserInfo', {
                            name: this.editForm.nickname,
                            avatar: this.editForm.avatar
                        });
                        this.$message.success('保存成功');
                        this.editDialogVisible = false;
                        this.saveLoading = false;
                    });
                }
            });
        },
        // 修改密码
        handleChangePassword() {
            this.$router.push('/mine/password');
        }
    }
}
</script>

<style lang="scss" scoped>
/* 基础样式 */
.mine-container {
    width: 100%;
    min-height: 100vh;
    background-color: #f5f7fa;
    padding: 20px;
    box-sizing: border-box;
}

/* 电脑端样式 */
.desktop-container {
    max-width: 800px;
    margin: 0 auto;
}

.content {
    background-color: white;
    border-radius: 8px;
    padding: 30px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.profile-card {
    width: 100%;
}

.profile-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.avatar-section {
    display: flex;
    align-items: center;
    gap: 20px;
}

.user-basic {
    display: flex;
    flex-direction: column;
    gap: 5px;
}

.user-name {
    margin: 0;
    font-size: 24px;
    font-weight: 600;
    color: #303133;
}

.user-role {
    margin: 0;
    font-size: 14px;
    color: #909399;
}

.section-title {
    margin: 0 0 20px 0;
    font-size: 16px;
    font-weight: 600;
    color: #303133;
}

.info-section {
    margin: 20px 0;
}

.info-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.info-item {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.info-label {
    font-size: 13px;
    color: #909399;
}

.info-value {
    font-size: 14px;
    color: #303133;
    font-weight: 500;
}

.action-section {
    margin-top: 20px;
}

.action-list {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.action-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 15px;
    background-color: #f5f7fa;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s;
}

.action-item:hover {
    background-color: #e6f7ff;
}

.action-left {
    display: flex;
    align-items: center;
    gap: 15px;
}

.action-icon {
    font-size: 20px;
    color: #409eff;
    width: 40px;
    height: 40px;
    background-color: #e6f7ff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.action-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.action-name {
    font-size: 14px;
    font-weight: 500;
    color: #303133;
}

.action-desc {
    font-size: 12px;
    color: #909399;
}

.action-arrow {
    font-size: 16px;
    color: #c0c4cc;
}

/* 手机端样式 */
.mobile-container {
    width: 100%;
    padding: 10px;
}

.mobile-profile-card {
    background-color: white;
    border-radius: 12px;
    overflow: hidden;
}

.mobile-profile-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 30px 20px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.mobile-user-info {
    margin-top: 15px;
    text-align: center;
}

.mobile-user-name {
    margin: 0;
    font-size: 20px;
    font-weight: 600;
    color: white;
}

.mobile-user-role {
    margin: 5px 0 0 0;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.8);
}

.cell-icon {
    margin-right: 8px;
    color: #409eff;
}

/* 头像上传样式 */
.avatar-upload-wrapper {
    display: flex;
    align-items: center;
    gap: 15px;
}

.avatar-uploader {
    display: inline-block;
}

/* 响应式调整 */
@media (max-width: 768px) {
    .mine-container {
        padding: 0;
        background-color: #f5f7fa;
    }
    
    .mobile-container {
        padding: 0;
    }
}

@media (max-width: 600px) {
    .info-grid {
        grid-template-columns: 1fr;
    }
}

@media (min-width: 769px) {
    .content {
        padding: 40px;
    }
}
</style>
